@if (item.customField10=='Type 1') {
<section class="sales-advantage-section">
    <div class="container">
        <div class="text-center">
            <h2 class="section-title" [style.font-size]="item.customField31"
                [ngStyle.lt-md]="{ 'font-size': item.customField32 }">{{ item.title }}</h2>
            <p class="section-subtitle"> <calsoft-editor-text [data]="data" [text]="item.customField20"
                    [style.font-size]="item.customField33" [ngStyle.lt-md]="{ 'font-size': item.customField34 }">
                </calsoft-editor-text></p>
        </div>

        <div class="comparison-grid" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="32px">
            <div class="comparison-card without-crm" fxFlex="1 1 50%">
                <h3 class="card-title" [style.font-size]="item.customField37"
                    [ngStyle.lt-md]="{ 'font-size': item.customField38 }">{{item.customField35}}</h3>
                <ul class="feature-list">
                    <li class="feature-item" *ngFor="let img of leftArray">
                        <span class="icon red">&times;</span>
                        <span><calsoft-editor-text [data]="data" [text]="img.customField7"
                                [style.font-size]="item.customField28"
                                [ngStyle.lt-md]="{ 'font-size': item.customField29 }">
                            </calsoft-editor-text></span>
                    </li>
                </ul>
            </div>

            <div class="comparison-card with-crm" fxFlex="1 1 50%">
                <h3 class="card-title" [style.font-size]="item.customField37"
                    [ngStyle.lt-md]="{ 'font-size': item.customField38 }">{{item.customField35}}</h3>
                <ul class="feature-list">
                    <li class="feature-item" *ngFor="let img of rightArray">
                        <span class="icon green">&#10004;</span>
                        <span><calsoft-editor-text [data]="data" [text]="img.customField7"
                                [style.font-size]="item.customField28"
                                [ngStyle.lt-md]="{ 'font-size': item.customField29 }">
                            </calsoft-editor-text></span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
}

@if (item.customField10=='Type 2') {
<section class="sales-advantage-section">
    <div class="container">
        <div class="text-center">
            <h2 class="section-title" [style.font-size]="item.customField31"
                [ngStyle.lt-md]="{ 'font-size': item.customField32 }">{{ item.title }}</h2>
            <p class="section-subtitle"> <calsoft-editor-text [data]="data" [text]="item.customField20"
                    [style.font-size]="item.customField33" [ngStyle.lt-md]="{ 'font-size': item.customField34 }">
                </calsoft-editor-text></p>
        </div>



        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" class="pricing-wrapper"
            fxLayoutGap="30px">
            <!-- Premium Card -->
            <div fxLayout="column" fxLayoutAlign="start  start" class="pricing-card premium-card">
                <h2 [style.font-size]="item.customField37" [ngStyle.lt-md]="{ 'font-size': item.customField38 }">
                    {{item.customField35}}</h2>
                <h1>{{item.customField18}}</h1>
                <ul fxLayout="column" fxLayoutAlign="start  start">
                    <li *ngFor="let img of leftArray">
                        <span class="check">✔</span><span>
                            <calsoft-editor-text [data]="data" [text]="img.customField7"
                                [style.font-size]="item.customField28"
                                [ngStyle.lt-md]="{ 'font-size': item.customField29 }">
                            </calsoft-editor-text></span>
                    </li>
                </ul>
    <a mat-raised-button [href]="item.customField16" class="action-button" target="_blank" rel="noopener">
                    {{ item.customField14 }}
                </a>
            </div>

            <!-- Custom Card -->
            <div fxLayout="column" fxLayoutAlign="start  start" class="pricing-card custom-card">
                <h2 [style.font-size]="item.customField37" [ngStyle.lt-md]="{ 'font-size': item.customField38 }">
                    {{item.customField35}}</h2>
                <h1>{{item.customField19}}</h1>
                <ul fxLayout="column" fxLayoutAlign="start  start">
                    <li *ngFor="let img of rightArray">
                        <span class="icon green">✨</span>
                        <span><calsoft-editor-text [data]="data" [text]="img.customField7"
                                [style.font-size]="item.customField28"
                                [ngStyle.lt-md]="{ 'font-size': item.customField29 }">
                            </calsoft-editor-text></span>
                    </li>

                </ul>
                <a mat-raised-button [href]="item.customField17" class="action-button" target="_blank" rel="noopener">
                    {{ item.customField15 }}
                </a>
            </div>

        </div>
    </div>  
</section>
}

<!-- <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" class="pricing-wrapper" fxLayoutGap="30px">
    
    <div fxLayout="column" fxLayoutAlign="start  start" class="pricing-card premium-card">
        <h2>Premium</h2>
        <h1>₹2,000<span class="per-year">/user/year</span></h1>
        <ul fxLayout="column" fxLayoutAlign="start  start">
            <li><span class="check">✔</span> WhatsApp CRM</li>
            <li><span class="check">✔</span> Lead scoring</li>
            <li><span class="check">✔</span> Custom reports</li>
            <li><span class="check">✔</span> All "Why Calsoft" benefits</li>
        </ul>
        <button mat-raised-button color="primary" class="action-button">Choose Premium</button>
    </div>

   
    <div fxLayout="column" fxLayoutAlign="start  start" class="pricing-card custom-card">
        <h2>Custom</h2>
        <h1>On request</h1>
        <ul fxLayout="column" fxLayoutAlign="start  start">
            <li>✨ Tailored features & integrations</li>
            <li>✨ Dedicated support</li>
            <li>✨ Scalable solutions</li>
            <li>✨ Priority access</li>
        </ul>
        <button mat-raised-button class="action-button">Talk to an Expert</button>
    </div>
</div> -->
